export default {
    props: {
        messagesApply: {
            type: String,
            kComposite: 'messages.apply'
        }, 
        messagesCancel: {
            type: String,
            kComposite: 'messages.cancel'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoFlatColorPicker/Messages.js